import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminDashboardEventKeys = {
  ADMIN_CASE_DASHBOARD_PAGE_VIEW: "admin-case-dashboard-page-view",
  ADMIN_COORDINATOR_DASHBOARD_PAGE_VIEW:
    "admin-coordinator-dashboard-page-view",
  ADMIN_COORDINATOR_DASHBOARD_TAB_CHANGE:
    "admin-coordinator-dashboard-tab-change",
  ADMIN_DASHBOARD_PAGE_VIEW: "admin-dashboard-page-view",
  ADMIN_LAYOUT_VIEW: "admin-layout-view",
  ADMIN_ORGANIZATION_REQUIRED: "admin-organization-required",
  ADMIN_PAGE_VIEW: "admin-page-view",
} as const;

export const AdminDashboardEventCatalog: EventCatalogFromKeys<
  typeof AdminDashboardEventKeys
> = {
  [AdminDashboardEventKeys.ADMIN_LAYOUT_VIEW]: {
    description: "Admin viewed the layout page",
    eventType: EventType.PAGE_VIEW,
    id: AdminDashboardEventKeys.ADMIN_LAYOUT_VIEW,
  },
  [AdminDashboardEventKeys.ADMIN_COORDINATOR_DASHBOARD_PAGE_VIEW]: {
    description: "Coordinator viewed the dashboard page",
    eventType: EventType.PAGE_VIEW,
    id: AdminDashboardEventKeys.ADMIN_COORDINATOR_DASHBOARD_PAGE_VIEW,
  },
  [AdminDashboardEventKeys.ADMIN_DASHBOARD_PAGE_VIEW]: {
    description: "Admin viewed the main dashboard page",
    eventType: EventType.PAGE_VIEW,
    id: AdminDashboardEventKeys.ADMIN_DASHBOARD_PAGE_VIEW,
  },
  [AdminDashboardEventKeys.ADMIN_CASE_DASHBOARD_PAGE_VIEW]: {
    description: "Case worker viewed the case dashboard page",
    eventType: EventType.PAGE_VIEW,
    id: AdminDashboardEventKeys.ADMIN_CASE_DASHBOARD_PAGE_VIEW,
  },
  [AdminDashboardEventKeys.ADMIN_COORDINATOR_DASHBOARD_TAB_CHANGE]: {
    description: "Coordinator changed tabs on the dashboard",
    eventType: EventType.INTERACTION,
    id: AdminDashboardEventKeys.ADMIN_COORDINATOR_DASHBOARD_TAB_CHANGE,
  },
  [AdminDashboardEventKeys.ADMIN_PAGE_VIEW]: {
    description: "Admin viewed the admin page",
    eventType: EventType.PAGE_VIEW,
    id: AdminDashboardEventKeys.ADMIN_PAGE_VIEW,
  },
  [AdminDashboardEventKeys.ADMIN_ORGANIZATION_REQUIRED]: {
    description: "Admin viewed the organization required page",
    eventType: EventType.PAGE_VIEW,
    id: AdminDashboardEventKeys.ADMIN_ORGANIZATION_REQUIRED,
  },
};
